import { createSlice } from '@reduxjs/toolkit';
import { fetchDailyPhotoContestData, submitDailyPhotoContestGuess } from '../thunks/dailyPhotoThunks';

const dailyPhotoSlice = createSlice({
    name: 'dailyPhoto',
    initialState: {
        photo: null,
        options: [],
        correctAnswer: null,
        isLoading: false,
        isSubmitting: false,
        error: null,
        lastSubmission: null,
        hasGuessedToday: false
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Handle fetch daily photo
            .addCase(fetchDailyPhotoContestData.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(fetchDailyPhotoContestData.fulfilled, (state, action) => {
                state.isLoading = false;
                state.photo = action.payload.photoUrl;
                state.options = action.payload.options;
                state.correctAnswer = action.payload.correctAnswer;
            })
            .addCase(fetchDailyPhotoContestData.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            // Handle submit guess
            .addCase(submitDailyPhotoContestGuess.pending, (state) => {
                state.isSubmitting = true;
                state.error = null;
            })
            .addCase(submitDailyPhotoContestGuess.fulfilled, (state, action) => {
                state.isSubmitting = false;
                state.lastSubmission = action.payload;
                state.hasGuessedToday = true;
            })
            .addCase(submitDailyPhotoContestGuess.rejected, (state, action) => {
                state.isSubmitting = false;
                state.error = action.payload;
            });
    }
});

export default dailyPhotoSlice.reducer; 